import { Languages } from '../../shared/language/Language';

export interface LanguageState {
  language: Languages;
}

export const initialLanguageState: LanguageState = {
  language: 'de',
};



// WEBPACK FOOTER //
// ./src/modules/language/state.tsx